import { useCallback, useMemo } from 'react';
import { usePageTour } from '@components/PageTour/usePageTour';
import { DOCUMENTS_TOUR_ID, type IDocumentsTourContext } from './documentsTour';

interface IUseDocumentsTourArgs extends IDocumentsTourContext {
  /** The folder tree is in. Files load per folder and are not waited for. */
  ready: boolean;
}

/** The Documents tour's seam on the page: the shared lifecycle plus the
 *  context its script reads. A dismissal closes whatever an action step opened. */
export function useDocumentsTour({ ready, hasFolders, hasDocumentRow, canUpload, closeUpload, closeDrawer }: IUseDocumentsTourArgs) {
  const onDismiss = useCallback(() => { closeUpload(); closeDrawer(); }, [closeUpload, closeDrawer]);
  const { open, dismiss, key } = usePageTour(DOCUMENTS_TOUR_ID, { ready, onDismiss });
  const context = useMemo<IDocumentsTourContext>(
    () => ({ hasFolders, hasDocumentRow, canUpload, closeUpload, closeDrawer }),
    [hasFolders, hasDocumentRow, canUpload, closeUpload, closeDrawer],
  );
  return { open, dismiss, key, context };
}
